/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import AccountService from 'cio/services/account';
import AnalyticsService from 'cio/services/analytics';
import { tracked } from '@glimmer/tracking';
import BillingService from 'cio/services/billing';
import { PlanType } from 'cio/models/plan';

interface UpsellModalArgs {
  plan: PlanType;
  isLink?: boolean;
}

export default class UpsellModal extends Component<UpsellModalArgs> {
  @service account!: AccountService;
  @service analytics!: AnalyticsService;
  @service auth!: AuthService;
  @service billing!: BillingService;

  @tracked isShowingModal = false;

  @action
  showModal() {
    this.isShowingModal = true;
    this.trackLetsTalkRequestViewed();
  }

  @action
  trackLetsTalkRequestViewed() {
    this.analytics.track('plan_billing', 'sales_or_contracts_lets_talk_clicked', {
      type: this.args.plan,
    });
  }
}
